import React, { useRef } from "react";
import { connect } from "react-redux";
import EmailEditor from "react-email-editor";
import { isJSON } from "Constants";
import sample from "./sample.json";

function NewemailEditor(props) {
  const emailEditorRef = useRef(null);

  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      console.log("exportHtml", html);
    });
  };

  const onReady = () => {
    // let html_data = JSON.parse(
    //   JSON.stringify(props.templateData.resource[0].welcome_contenthtml)
    // );
    // const templateJson = { data };
    emailEditorRef.current.editor.loadDesign(sample);
  };

  return (
    <>
      <div>
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={exportHtml}>
            Export HTML
          </button>
        </div>
        <EmailEditor
          ref={emailEditorRef}
          onReady={onReady}
          //   onLoad={onReady}
          style={{ height: "75vh" }}
        />
      </div>
    </>
  );
}

function mapStateToProps(state) {
  var { session, templateData } = state;

  return {
    session,
    templateData,
  };
}

export default connect(mapStateToProps, {})(NewemailEditor);
